export const fonts = {
  heading: 'Inter, sans-serif',
  body: 'Inter, sans-serif',
};

export const fontSizes = {
  // xs: '0.75rem',
  // sm: '0.8125rem',
  // md: '0.875rem',
  // lg: '1',
  // xl: '1.125rem',
  // '2xl': '1.5rem',
  // '3xl': '1.875rem',
  // '4xl': '2.25rem',
  // '5xl': '3rem',
  // '6xl': '3.75rem',
  // '7xl': '4.5rem',
  // '8xl': '6rem',
  // '9xl': '8rem',
};

export const textStyles = {
  h1: {
    fontSize: ['4xl', null, '6xl'],
    fontWeight: 'extrabold',
    lineHeight: '1.2',
    letterSpacing: '-2%',
  },
  h2: {
    fontSize: ['36px', '48px'],
    fontWeight: '900',
    lineHeight: '110%',
    letterSpacing: '-1%',
  },
  h3: {
    fontSize: ['lg', 'xl'],
    fontWeight: '900',
    lineHeight: '110%',
    letterSpacing: '-1%',
  },
  subtitle: {
    fontSize: ['lg', null, '2xl'],
    fontWeight: 'normal',
  },
};
